/*
 * slick-a11y.js — sanitize the ARIA that the (old) slick carousel emits at runtime.
 *
 * Audit #13: slick generates invalid combinations that PageSpeed/axe flag:
 *   - <li role="presentation" aria-selected="…" aria-controls="…">  (aria-* invalid on presentation)
 *   - <ul class="slick-dots" role="tablist"> with children that are not role="tab"
 *   - <div class="slick-track" role="listbox"> with no accessible name
 * We can't easily patch the bundled library, so we correct the DOM after slick
 * writes it, and re-run on slick's own events (it re-applies ARIA on reInit/resize).
 */
(function () {
  function sanitize() {
    var sliders = document.querySelectorAll('.slick-slider');
    for (var i = 0; i < sliders.length; i++) {
      var slider = sliders[i];

      // Container: expose as a labelled carousel group.
      if (!slider.getAttribute('role')) slider.setAttribute('role', 'group');
      slider.setAttribute('aria-roledescription', 'carousel');
      if (!slider.getAttribute('aria-label') && !slider.getAttribute('aria-labelledby')) {
        slider.setAttribute('aria-label', 'Content carousel');
      }

      // Track: slick marks it role="listbox" without a name — drop the role.
      var tracks = slider.querySelectorAll('.slick-track');
      for (var t = 0; t < tracks.length; t++) tracks[t].removeAttribute('role');

      // Slides: presentation + aria-selected/aria-controls is invalid → normalise to slide group.
      var slides = slider.querySelectorAll('.slick-slide, li[id^="slick-slide"]');
      for (var s = 0; s < slides.length; s++) {
        slides[s].removeAttribute('aria-selected');
        slides[s].removeAttribute('aria-controls');
        slides[s].setAttribute('role', 'group');
        slides[s].setAttribute('aria-roledescription', 'slide');
      }

      // Any aria-controls whose target id does not exist is an INVALID VALUE → drop it.
      var controlled = slider.querySelectorAll('[aria-controls]');
      for (var ci = 0; ci < controlled.length; ci++) {
        var ref = controlled[ci].getAttribute('aria-controls');
        if (!ref || !document.getElementById(ref)) controlled[ci].removeAttribute('aria-controls');
      }

      // Dots: tablist without role="tab" children → make it a plain list of buttons.
      var dotLists = slider.querySelectorAll('.slick-dots');
      for (var d = 0; d < dotLists.length; d++) {
        dotLists[d].removeAttribute('role');
        var lis = dotLists[d].querySelectorAll('li');
        for (var l = 0; l < lis.length; l++) {
          lis[l].removeAttribute('role');
          lis[l].removeAttribute('aria-selected');
        }
        var btns = dotLists[d].querySelectorAll('button');
        for (var b = 0; b < btns.length; b++) {
          btns[b].removeAttribute('aria-controls');
          if (!btns[b].getAttribute('aria-label')) {
            btns[b].setAttribute('aria-label', 'Go to slide ' + (b + 1));
          }
        }
      }

      // Arrows: give the icon-only buttons an accessible name.
      var prev = slider.querySelectorAll('.slick-prev');
      for (var p = 0; p < prev.length; p++) {
        if (!prev[p].getAttribute('aria-label')) prev[p].setAttribute('aria-label', 'Previous slide');
      }
      var next = slider.querySelectorAll('.slick-next');
      for (var n = 0; n < next.length; n++) {
        if (!next[n].getAttribute('aria-label')) next[n].setAttribute('aria-label', 'Next slide');
      }
    }
  }

  var busy = false; // guard so our own attribute edits don't re-trigger the observer in a loop
  function run() {
    if (busy) return;
    busy = true;
    try { sanitize(); } catch (e) { /* never break the page over a11y polish */ }
    busy = false;
  }

  // Re-run on slick's lifecycle events (it rewrites ARIA on init/reInit/resize).
  if (window.jQuery) {
    window.jQuery(function ($) {
      $(document).on('init reInit afterChange setPosition breakpoint', '.slick-slider', function () {
        // Defer so slick finishes writing attributes first.
        window.setTimeout(run, 0);
      });
    });
  }

  // Bulletproof: slick re-applies aria-controls/aria-selected on every reposition,
  // which can race the event handler above. A MutationObserver strips the invalid
  // values the instant slick writes them, with no timing assumptions.
  function observe() {
    if (!window.MutationObserver) return;
    var sliders = document.querySelectorAll('.slick-slider');
    for (var i = 0; i < sliders.length; i++) {
      if (sliders[i].__a11yObserved) continue;
      sliders[i].__a11yObserved = true;
      var mo = new MutationObserver(function () {
        if (busy) return;
        window.setTimeout(run, 0);
      });
      mo.observe(sliders[i], {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['aria-controls', 'aria-selected', 'role']
      });
    }
  }

  function boot() { run(); observe(); }

  // Fallbacks for carousels initialised before this handler bound.
  if (document.readyState !== 'loading') {
    window.setTimeout(boot, 300);
  } else {
    document.addEventListener('DOMContentLoaded', function () { window.setTimeout(boot, 300); });
  }
  window.addEventListener('load', function () { window.setTimeout(boot, 600); });
})();
